import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { AccountManager } from '@atlas/core';
import { MoneyInput } from '@atlas/ui';

import Field from 'common/Form/Field';

const MoneyAmountField = ({ field, onBlur = () => {}, onChange, onFocus = () => {} }) => {
  const { active, autofocus, disabled, errors, label, name, touched, value } = field;
  const currency = AccountManager.getAccountCurrency();

  const changeHandler = useCallback(
    value => {
      const newValue = Number(value) ?? null;
      onChange(newValue);
    },
    [onChange],
  );
  const error = touched && errors[0];

  return (
    <Field options={field}>
      <MoneyInput
        active={active}
        autoFocus={autofocus}
        currency={currency}
        disabled={disabled}
        error={error}
        label={label}
        name={name}
        onBlur={onBlur}
        onChange={changeHandler}
        onFocus={onFocus}
        touched={touched}
        value={value}
      />
    </Field>
  );
};

MoneyAmountField.propTypes = {
  field: PropTypes.object.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

export default MoneyAmountField;
